<coa-list-no-data
  [subTitle]="''"
  [title]="'No data for custom groups.' | translate">
</coa-list-no-data>
